// Status constants
export const STATUS_CLOSED = "closed";
export const STATUS_WIP = "wip";
export const STATUS_OPEN = "open";
export const STATUS_NREL = "n.rel.";

// Color formatting
export const COLORS = {
  CLOSED: {
    bg: "C6EFCE",
    font: "006100",
  },
  OPEN: {
    bg: "FFC7CE",
    font: "9C0006",
  },
  WIP: {
    bg: "FFEB9C",
    font: "9C6500",
  },
  DATA_BAR: {
    fill: "C6EFCE",
    font: "006100",
  },
};

// Table configuration
export const TABLE_CONFIG = {
  name: "MyTable",
  startRow: 2,
  dataStartRow: 3,
  showRowStripes: true,
};
